"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = BundleVariant;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = require("@linaria/react");
var _react2 = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = _interopRequireDefault(require("@ux/text"));
var _intents = _interopRequireDefault(require("@site/pattern-library-utils/intents"));
var _patternLibraryUtils = require("@site/pattern-library-utils");
var _paragraph = _interopRequireDefault(require("@site/pattern-library-core/paragraph"));
var _list = _interopRequireDefault(require("@site/pattern-library-core/list"));
var _tag = _interopRequireDefault(require("@site/pattern-library-core/tag"));
var _tagItem = _interopRequireDefault(require("../filters/tag-item"));
var _productTileActions = _interopRequireDefault(require("../product-tile-actions"));
var _productList = _interopRequireDefault(require("../product-list"));
/* VENDOR */

/* LOCAL */

const BundleVariantContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "BundleVariantContainer",
  class: "pl-bs52lr8"
});
const Flag = /*#__PURE__*/(0, _react.styled)(_tag.default)({
  name: "Flag",
  class: "pl-f1wy0ymv"
});
const Header = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Header",
  class: "pl-hjglc4o"
});
const TagContainer = /*#__PURE__*/(0, _react.styled)("div")({
  name: "TagContainer",
  class: "pl-tcda9ur"
});
const Content = /*#__PURE__*/(0, _react.styled)("div")({
  name: "Content",
  class: "pl-c1ubo9ol"
});
const RecommendedList = /*#__PURE__*/(0, _react.styled)("ul")({
  name: "RecommendedList",
  class: "pl-r1g2kzfv"
});
const BundleList = /*#__PURE__*/(0, _react.styled)(_list.default)({
  name: "BundleList",
  class: "pl-bf56d6o"
});
function BundleVariant({
  _name,
  bundleName,
  bundleDescription,
  linkText,
  linkHref,
  saleFlagText,
  cta,
  priceLockup,
  bundleList,
  productHeading,
  productList,
  recommendedHeading,
  recommendedList,
  productTags,
  gridIndex,
  trackingCustomProperties = {},
  ...rest
}) {
  productHeading = productHeading?.Text;
  recommendedHeading = recommendedHeading?.Text;
  trackingCustomProperties.plp_order = gridIndex;
  return /*#__PURE__*/_react2.default.createElement(BundleVariantContainer, rest, saleFlagText && /*#__PURE__*/_react2.default.createElement(Flag, {
    "data-cy": "flag",
    text: saleFlagText,
    design: "warning"
  }), /*#__PURE__*/_react2.default.createElement(Header, {
    "data-cy": "header"
  }, /*#__PURE__*/_react2.default.createElement("h2", {
    "data-cy": "heading"
  }, bundleName), productTags && /*#__PURE__*/_react2.default.createElement(TagContainer, null, productTags?.slice(0, 3).map(({
    tagName: {
      Text: label
    }
  }, i) => label && /*#__PURE__*/_react2.default.createElement(_tagItem.default, {
    variant: "tile",
    key: i,
    label: label
  }))), /*#__PURE__*/_react2.default.createElement(_paragraph.default, {
    dataCy: "description",
    text: bundleDescription
  }), /*#__PURE__*/_react2.default.createElement("a", (0, _extends2.default)({
    "data-cy": "tile-link",
    href: linkHref
  }, _patternLibraryUtils.tracking.create(`tile_link_${_name}`, true, false, trackingCustomProperties)), /*#__PURE__*/_react2.default.createElement(_text.default.span, {
    as: "paragraph",
    size: -1
  }, linkText)), /*#__PURE__*/_react2.default.createElement(_productTileActions.default, {
    actionsLayout: "price-lockup-and-button",
    priceLockup: priceLockup,
    cta: cta,
    trackingCustomProperties: trackingCustomProperties
  })), /*#__PURE__*/_react2.default.createElement("hr", null), /*#__PURE__*/_react2.default.createElement(Content, {
    "data-cy": "content"
  }, /*#__PURE__*/_react2.default.createElement(BundleList, {
    dataCy: "bundle-list",
    listType: "icons",
    iconType: "ok-filled",
    iconColor: _intents.default.ux.box.foregroundColor,
    items: bundleList.items?.slice(0, 12)
  }), /*#__PURE__*/_react2.default.createElement(_text.default.h3, {
    as: "paragraph",
    size: -1,
    "data-cy": "product-list-heading"
  }, productHeading), /*#__PURE__*/_react2.default.createElement(_productList.default, {
    dataCy: "product-list",
    items: productList.items
  }), /*#__PURE__*/_react2.default.createElement(_text.default.h3, {
    as: "paragraph",
    size: -1,
    "data-cy": "recommended-list-heading"
  }, recommendedHeading), /*#__PURE__*/_react2.default.createElement(RecommendedList, {
    "data-cy": "recommended-list"
  }, recommendedList.items?.slice(0, 3).map(({
    content
  }, i) => /*#__PURE__*/_react2.default.createElement("li", {
    key: i
  }, content)))));
}
BundleVariant.propTypes = {
  _name: _propTypes.default.string.isRequired,
  bundleName: _propTypes.default.string.isRequired,
  bundleDescription: _propTypes.default.string.isRequired,
  productTags: _propTypes.default.array,
  linkText: _propTypes.default.string,
  linkHref: _propTypes.default.string,
  saleFlagText: _propTypes.default.string,
  cta: _propTypes.default.object.isRequired,
  priceLockup: _propTypes.default.object.isRequired,
  bundleList: _propTypes.default.object.isRequired,
  productHeading: _propTypes.default.string.isRequired,
  recommendedHeading: _propTypes.default.string.isRequired,
  productList: _propTypes.default.object.isRequired,
  recommendedList: _propTypes.default.object.isRequired,
  gridIndex: _propTypes.default.number.isRequired,
  trackingCustomProperties: _propTypes.default.object
};